// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2a5e587b","732":"8b42a3d5"}[chunkId] + ".chunk.js";
};